import { IError, isApiError } from '@/types/error'

const TOKEN_VERIFICATION_FAILED_INFO = 'Token verification failed'

// fz-user-profile's rejected-token code (PRO-781). Its 5001 carries the same
// info for auth outages too, and AccessGuard's 4011 carries a different info,
// so only the pair of both identifies a dead session.
const SESSION_REJECTED_CODE = '4011'

export const isTokenVerificationFailure = (error: unknown): error is IError =>
  isApiError(error) && error.extra?.info === TOKEN_VERIFICATION_FAILED_INFO

export const isSessionRejected = (error: unknown): boolean =>
  isTokenVerificationFailure(error) && String(error.code) === SESSION_REJECTED_CODE
